import { render, staticRenderFns } from "./HistoryWindow.vue?vue&type=template&id=35e0ca99&scoped=true&"
import script from "./HistoryWindow.vue?vue&type=script&lang=js&"
export * from "./HistoryWindow.vue?vue&type=script&lang=js&"
import style0 from "./HistoryWindow.vue?vue&type=style&index=0&id=35e0ca99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e0ca99",
  null
  
)

export default component.exports